import React, { useContext, useEffect, useState } from 'react'
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { Container, Col, Row, Card } from "react-bootstrap";
import { ThemeContext } from "../theming";
import Engranaje from "../assets/images/engranaje.png";
import useWindowDimensions from '../helpers/useWindowDimensions';
import { TextColored } from '../components/typography';
import Gears from "../components/gears";
import { WEB_PROGRESO, APIINTEGRACION } from "../helpers/url";
import CustomButton from '../components/buttons/Button';
import { useNavigate } from 'react-router-dom';

function Error() {
    const history = useNavigate();
    const { width, height } = useWindowDimensions();
    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const containerMobile = {
        width: '100%',
        height: width >= 375 ? '100%' : '',
        background: 'white',
        padding: '20px',
    };

    const app = useContext(ThemeContext);
    const { body14, body28, body30 } = app.theme.font;
    let user =  JSON.parse(localStorage.getItem('user'));
    let t = localStorage.getItem('t');
    const redirect = ()=>{
        if(user != null && t != null){
            history(`/auth/${user.r}?w=${user.w}&n=${user.n}&t=${t}`)
        }else{
            window.location.href = WEB_PROGRESO;
        }
    }
    return (
        <>
            <section style={{ width: "100%", height: `${height-220}px` }}>
                <Header />
                <Container className="error justify-content-center" style={width >= 701 ? container : containerMobile} fluid>
                    <Col xs={9} lg={6} style={{ margin: "75px 0px" }}>
                        <Row>
                            <Card style={{
                                    backgroundColor: "white",
                                    width: "100%",
                                    height: "100%",
                                    padding: "32px 12px"
                            }}>
                                <Row className="justify-content-center">
                                    <img style={{ width: "120px" }} alt="" src={Engranaje} />
                                </Row>
                                <Row className="justify-content-center py-2">
                                    <TextColored size={body30} bold={true} type="dark" style={{ fontWeight : 600}}>
                                        UPS!
                                    </TextColored>
                                    <TextColored size={body30} bold={true} type="dark" style={{ fontWeight : 600}}>
                                        OCURRIÓ UN ERROR INESPERADO
                                    </TextColored>
                                </Row>
                                <Row className="mt-3">
                                    <TextColored size={body28} type="dark">
                                        No te preocupes, lo estaremos revisando.
                                    </TextColored>
                                </Row>
{/*                                 <Row className="mt-5">
                                    <Gears />
                                </Row> */}
                                <Row className="mt-4 justify-content-center" xs={1} sm={3}>
                                    <Col>
                                        <a onClick={redirect}>
                                            <CustomButton size={body14} sizeText={1.4} styleText={{ fontWeight : 600}}>
                                                Volver al inicio
                                            </CustomButton>
                                        </a>
                                    </Col>
                                </Row>
                            </Card>
                        </Row>
                    </Col>
                </Container>
                <Footer margin={false} />
            </section>
        </>
    )
}

export default Error